export default {
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setProfiles(state, profiles) {
    state.profiles = profiles;
  },
  setProfile(state, profile) {
    state.profile = profile;
  },
  setInvites(state, invites) {
    state.invites = invites;
  },
  setInvite(state, invite) {
    state.invite = invite;
  },
  setPartners(state, partners) {
    state.partners = partners;
  },
  setInvitesReceived(state, invitesReceived) {
    state.invitesReceived = invitesReceived;
  },
  setInvitesSent(state, invitesSent) {
    state.invitesSent = invitesSent;
  },
  setMyColabs(state, myColabs) {
    state.myColabs = myColabs;
  }
};
